import { PAGE_SIZE } from "@joogoos/contracts";

/**
 * A line under a list the server pages (2026-09-23): "11–20 of 143", and Previous and Next. The Credits panel's
 * purchases, movements and calls all use it; each asks the server for the page it is turned to, so the whole
 * history is there to be read, not the newest hundred of it.
 */
export function Pager({ page, total, onPage, label }: { page: number; total: number; onPage: (page: number) => void; label: string }) {
  const pages = Math.ceil(total / PAGE_SIZE);
  if (pages <= 1) return null;
  const from = page * PAGE_SIZE + 1;
  const to = Math.min(total, from + PAGE_SIZE - 1);
  const btn = "px-2.5 py-1 rounded-lg text-xs font-medium bg-page text-ink-2 hover:bg-line disabled:opacity-40 disabled:hover:bg-page";
  return (
    <nav aria-label={label} className="flex items-center justify-end gap-2 pt-2 text-[12px] text-muted">
      <span className="tabular-nums mr-auto">{from}–{to} of {total}</span>
      <button className={btn} disabled={page === 0} onClick={() => onPage(page - 1)}>Previous</button>
      <span className="tabular-nums">{page + 1} / {pages}</span>
      <button className={btn} disabled={page >= pages - 1} onClick={() => onPage(page + 1)}>Next</button>
    </nav>
  );
}
